import { render, staticRenderFns } from "./AForgotPassword.vue?vue&type=template&id=dd801090"
import script from "./AForgotPassword.vue?vue&type=script&lang=js"
export * from "./AForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports